var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tabs',{attrs:{"itemTabs":_vm.itemTabs,"currentTab":_vm.currentTab,"badgeData":['', _vm.totalStatusWaitingReschedule]},on:{"tabsClick":_vm.onTabsClick}}),_c('div',{staticClass:"mt-6"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }